<template>
  <el-popover
    class="ny-popover"
    :placement="placement"
    :width="width"
    v-model="visible"
    v-bind="$attrs"
  >
    <p class="ny-popover__tip">{{tipText}}</p>
    <div style="text-align: right; margin: 0">
      <el-button class="is-text" size="small" @click="visible = false">取消</el-button>
      <el-button type="primary" size="small" @click="confirm">确定</el-button>
    </div>
    <template v-if="$slots.reference">
      <slot slot="reference" name="reference"></slot>
    </template>
  </el-popover>
</template>

<script>
const noop = function () { }

export default {
  name: 'NyPopover',
  props: {
    value: {},
    placement: {
      type: String,
      default: 'top'
    },
    width: {
      type: [String, Number],
      default: '160'
    },
    tipText: String,
    confirm: {
      type: Function,
      default: noop
    }
  },
  data () {
    return {
      visible: this.value
    }
  },
  watch: {
    value (newVal) {
      this.visible = newVal
    },
    visible (newVal) {
      this.$emit('input', newVal)
      this.$emit('change', newVal)
    }
  }
}
</script>

<style lang="scss">
@include b(ny-popover) {
  @include e(tip) {
    padding: 5px 0 10px;
  }
}
</style>
